import { AccountSectionColumns } from '@juvare/contact-management/backend/config/classifiers/AccountSectionClassifier/shared';
import { UserState } from '@juvare/platform-sdk-react/types';
import { Row } from '@juvare/platform-shared/features/storage';

export function filterAccountSections(userState: UserState, sections: Row<AccountSectionColumns>[]): Row<AccountSectionColumns>[] {
    return sections.filter((section) => {
        if (section.columns.key === 'badgesSection') {
            return userState.badging.badgingEnabled;
        }
        return true;
    });
}
